import { Component, OnInit, OnDestroy } from "@angular/core";
import { ITCITenantComponentOutput, TCITenantSelectorType, TCIMetricsLabelType } from "@tci/common";
import { AbstractTCITenantComponent } from "../../../../ng-tenant/tci-tenant-component";
import { BaseAppDetailMenuComponentInput } from "../../../../ng-app-details/ng-app-details-menu";
import { BaseAppListPeekService } from "../base-app-list-peek.service";
import { INgBarGraphValue } from "../../../../ng-shared/ng-components/ng-bar-graph/ng-bar-graph.component";
import { displayBigNumber } from "../../../../ng-shared/ng-util/tools";
import { Subscription } from "rxjs";

@Component({
    selector: TCITenantSelectorType.TCI_APP_LIST_MONITORING_APP_PEEK_EXEC.toString(),
    templateUrl: "./base-app-list-peek-exec.component.html",
    styleUrls: ["./base-app-list-peek-exec.component.css"]
})
export class BaseAppListPeekExecComponent<E, I extends BaseAppDetailMenuComponentInput, O extends ITCITenantComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O> implements OnInit, OnDestroy {
    barInput: INgBarGraphValue[] = [];

    executionsCount: string;

    loading = true;
    showBar = false;

    private subscriptions: Subscription[] = [];

    constructor(private peekSrv: BaseAppListPeekService) {
        super();

        this.subscriptions.push(
            this.peekSrv.getMetricsRefreshSubj()
                .filter(() => !!(this.input && this.input.getApplication()))
                .filter(res => res === this.input.getApplication().id)
                .subscribe(() => this.refreshMetrics())
        );
    }

    ngOnInit() {
        this.refreshMetrics();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subs => subs.unsubscribe());
    }

    private refreshMetrics() {
        this.peekSrv.getAppMetrics(this.input.getApplication())
            .finally(() => this.loading = false)
            .filter(res => !!(res && res.labeledAppMetrics && res.labeledAppMetrics[TCIMetricsLabelType.tci_app_executions]))
            .subscribe(res => {
                const data = res.labeledAppMetrics[TCIMetricsLabelType.tci_app_executions];

                const successData = data.find(d => d.labels.status === "success");
                const successVal = successData ? Number(successData.value) : 0;

                const faultedData = data.find(d => d.labels.status === "failure");
                const faultedVal = faultedData ? Number(faultedData.value) : 0;

                this.barInput = [
                    { label: "successful", unit: "", value: successVal, bgColor: "#31429c", txtColor: "white" },
                    { label: "failure", unit: "", value: faultedVal, bgColor: "#a6acd1" }
                ];

                this.executionsCount = displayBigNumber(successVal + faultedVal);

                this.showBar = (successVal + faultedVal) > 0;
            });
    }
}
